// Travel Sauce - Main JavaScript

// ========================================
// FAQ Accordion
// ========================================
const faqItems = document.querySelectorAll('.faq-item');

faqItems.forEach(item => {
  const question = item.querySelector('.faq-question');

  question.addEventListener('click', () => {
    const isActive = item.classList.contains('active');

    // Close all FAQ items
    faqItems.forEach(faq => faq.classList.remove('active'));

    // Toggle clicked item
    if (!isActive) {
      item.classList.add('active');
    }
  });
});

// ========================================
// Smooth Scroll
// ========================================
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));

    if (target) {
      const navHeight = document.querySelector('.navbar').offsetHeight;
      const targetPosition = target.offsetTop - navHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});

// ========================================
// Mobile Menu Toggle
// ========================================
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const navLinks = document.querySelector('.nav-links');

if (mobileMenuBtn) {
  mobileMenuBtn.addEventListener('click', () => {
    navLinks.classList.toggle('active');
    mobileMenuBtn.classList.toggle('active');
  });
}

// ========================================
// Newsletter Form
// ========================================
const newsletterForm = document.querySelector('.newsletter-form');

if (newsletterForm) {
  newsletterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = newsletterForm.querySelector('input[type="email"]').value;

    // Show success message
    alert(`Thank you for subscribing! We'll send updates to ${email}`);
    newsletterForm.reset();
  });
}

// ========================================
// Add to Cart Buttons (Shopify Integration Placeholder)
// ========================================
const addToCartButtons = document.querySelectorAll('[data-product]');

addToCartButtons.forEach(button => {
  button.addEventListener('click', () => {
    const product = button.getAttribute('data-product');

    // Temporary alert - will be replaced with Shopify Buy Button
    alert(`Adding "${product}" to cart! (Shopify integration will be added next)`);

    // Add animation
    button.textContent = '✓ Added!';
    button.style.backgroundColor = '#10b981';

    setTimeout(() => {
      button.textContent = 'Add to Cart';
      button.style.backgroundColor = '';
    }, 2000);
  });
});

// ========================================
// Scroll Animations (Intersection Observer)
// ========================================
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

// Observe elements for animation
document.querySelectorAll('.testimonial-card, .problem-card').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(20px)';
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  observer.observe(el);
});

// ========================================
// Navbar Scroll Effect
// ========================================
let lastScroll = 0;
const navbar = document.querySelector('.navbar');

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;

  if (currentScroll > 100) {
    navbar.style.boxShadow = '0 4px 6px -1px rgb(0 0 0 / 0.1)';
  } else {
    navbar.style.boxShadow = '0 1px 2px 0 rgb(0 0 0 / 0.05)';
  }

  lastScroll = currentScroll;
});

console.log('Travel Sauce website loaded successfully!');

// ========================================
// Kit Detail Modals
// ========================================
function openKitModal(id) {
  var overlay = document.getElementById('modal-' + id);
  if (overlay) {
    // Re-parent the overlay to <body> before showing it. The shop-page modals are
    // rendered inside .product-card, and .product-card:hover applies a transform,
    // which creates a containing block that traps position:fixed — making the modal
    // render *inside* the card and strobe. Moving it to <body> guarantees the fixed
    // overlay is relative to the viewport. The element keeps its own event listeners.
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

function closeKitModal(id) {
  var overlay = document.getElementById('modal-' + id);
  if (overlay) {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Close modal when clicking the backdrop
document.querySelectorAll('.kit-modal-overlay').forEach(function(overlay) {
  overlay.addEventListener('click', function(e) {
    if (e.target === this) {
      this.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
});

// Close modal on Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.kit-modal-overlay.active').forEach(function(modal) {
      modal.classList.remove('active');
    });
    document.body.style.overflow = '';
  }
});
